import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { SectionTitleWrapper } from '../Info.styles';

import { RowWrapper, EmojiWrapper, ItemWrapper, TagsWrapper, Wrapper } from './InfoContent.styles';

import { CourseStatusTag } from '@/components/CourseStatusTag';
import { CsatTag } from '@/components/CsatTag';
import { QuizAverageTag } from '@/components/QuizAverageTag';
import { useCourseStats, useProfile } from '@/store';
import { calculateCourseTasksProgress } from '@/utils';

export const InfoContent = () => {
  const { t } = useTranslation('CourseTranslations');
  const { courseStats } = useCourseStats();
  const {
    roleCheck: { isTeacher }
  } = useProfile();

  if (!courseStats) return null;

  return (
    <Wrapper>
      <SectionTitleWrapper>{t('GENERAL_INFO')}</SectionTitleWrapper>
      <ItemWrapper>
        <div>{t('COURSE_TITLE')}</div>
        <div>{courseStats.course.name}</div>
      </ItemWrapper>
      <ItemWrapper>
        <div>{t('TEACHERS')}</div>
        <TagsWrapper>
          {courseStats.course.teachers.map(teacher => (
            <Tag key={teacher._id}>{`${teacher.name} ${teacher.lastName}`}</Tag>
          ))}
        </TagsWrapper>
      </ItemWrapper>
      <ItemWrapper>
        <div>{t('TAGS')}</div>
        <TagsWrapper>
          {courseStats?.tags.map(tag => (
            <Tag key={tag._id}>{tag.name}</Tag>
          ))}
        </TagsWrapper>
      </ItemWrapper>
      <ItemWrapper>
        <div>{t('COURSE_EMOJI')}</div>
        <EmojiWrapper>{courseStats.course.emoji}</EmojiWrapper>
      </ItemWrapper>
      {!isTeacher && (
        <>
          <RowWrapper>
            <ItemWrapper>
              <div>{t('SECTIONS_REVIEW')}</div>
              <div>{t(courseStats.course.sectionReviewRequirement)}</div>
            </ItemWrapper>
            <ItemWrapper>
              <div>{t('PLANIFICABLE')}</div>
              <div>
                {t(
                  courseStats.course.isPlanificable
                    ? 'PLANIFICABLE_ACTIVATED'
                    : 'PLANIFICABLE_INACTIVATED'
                )}
              </div>
            </ItemWrapper>
          </RowWrapper>
          <RowWrapper>
            <ItemWrapper>
              <div>{t('TASK_PROGRESS')}</div>
              <div>{`${calculateCourseTasksProgress(courseStats.course.sections)}%`}</div>
            </ItemWrapper>
            <ItemWrapper>
              <div>{t('STATUS')}</div>
              <CourseStatusTag status={courseStats.course.status} />
            </ItemWrapper>
          </RowWrapper>
          <RowWrapper>
            <ItemWrapper>
              <div>{t('COURSE_STUDENTS')}</div>
              <div>{courseStats.studentCount}</div>
            </ItemWrapper>
            <ItemWrapper>
              <div>{t('CSAT')}</div>
              <CsatTag csat={courseStats?.csat} />
            </ItemWrapper>
          </RowWrapper>
          <RowWrapper>
            <ItemWrapper>
              <div>{t('COURSE_QUIZ_AVG_SCORE')}</div>
              <QuizAverageTag score={courseStats.avgScore} />
            </ItemWrapper>
            <ItemWrapper>
              <div>{t('TOTAL_TICKETS')}</div>
              <div>{courseStats.ticketsCount}</div>
            </ItemWrapper>
          </RowWrapper>
        </>
      )}
    </Wrapper>
  );
};
